import { inject, ref, type InjectionKey, type Ref } from 'vue';

/**
 * Public injection key carrying the `tabId` of the enclosing `NxTabpanel`.
 * Provided by every `NxTabpanel`, so descendants (e.g. section components)
 * can read which tab they live in without prop-drilling.
 */
export const tabIdInjectionKey = Symbol('nx-tab-id') as InjectionKey<Ref<string>>;

/**
 * Returns the `tabId` of the nearest `NxTabpanel` ancestor as a ref.
 * Falls back to an empty ref when called outside a panel, so sections can also
 * render in explicit layout containers that do not use `NxTabpanel`.
 */
export function useTabId(): Ref<string> {
  const injected = inject(tabIdInjectionKey, null);
  if (!injected) return ref('');
  return injected;
}
